<template>
	<div :class="dialog==1?'':'app-container'">
		<el-table
			:data="formData"
			border
			fit
			:max-height="437"
			style="width: 100%"
		>
			<el-table-column align="center" label="操作" width="100">
				<template slot-scope="{ row }">
					<el-button
						size="mini"
						icon="el-icon-plus"
						circle
						@click="addRow(row)"
					/>
					<el-button
						size="mini"
						icon="el-icon-minus"
						type="danger"
						circle
						@click="removeRow(row)"
					/>
				</template>
			</el-table-column>

			<template v-for="(col, index) in cols">
				<el-table-column
					:key="index"
					:label="col.label"
					:width="col.width"
					:align="col.align"
					:min-width="col.min_width"
					:class-name="col.class"
				>
					<template slot-scope="{ row }">
						<template v-if="col.edit">
							<template v-if="col.type === 'typeEdit'">
								<template>
									<el-select style="width:100%" v-model="row.type" placeholder="">
										<el-option key="2" label="财务收入" value="2"></el-option>
										<el-option key="3" label="财务支出" value="3"></el-option>
									</el-select>
								</template>
							</template>
							<template v-else-if="col.type === 'payEdit'">
								<template>
									<el-select v-model="row.category" clearable  style="width:100%">
										<el-option :label="ca.label" v-for="ca in category" :key="ca.id" :value="ca.id"></el-option>
									</el-select>
								</template>
							</template>
							<template v-else-if="col.type === 'dataEdit'">
								<el-date-picker style="width:100%" :editable="false" v-model="row.date" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" />
							</template>
							<template v-else-if="col.type === 'accountEdit'">
								<template>
									<el-select style="width:100%" v-model="row.accountid">
										<el-option v-for="item in accountid" :key="item.id" :label="item.name+'('+item.account+')'" :value="item.id">
										</el-option>
									</el-select>
								</template>
							</template>
							<template v-else-if="col.type === 'countEdit'">
								<el-input v-model="row.amount" :min="0" type="number" @input="$common.checkMoney($event,row,'amount')"/>
							</template>
							<template v-else-if="col.type === 'remarkEdit'">
								<el-input  maxlength="50" v-model="row.remark" />
							</template>
						</template>
					</template>
				</el-table-column>
			</template>
		</el-table>
		<div class="rootbtn">
			<el-button type="primary" @click="save">确认</el-button>
			<el-button @click="cancel">取消</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			dialog: {
				type: Number,
				default: 0
			}
		},
		data() {
			return {
				cols: [
					{
						prop: "type",
						label: "类型",
						edit: "typeEdit",
						type: "typeEdit",
						min_width: 130,
					},
					{
						prop: "amount",
						label: "金额(元)",
						edit: "countEdit",
						type: "countEdit",
						width: 130,
					},
					{
						prop: "category",
						label: "财务分类",
						edit: "payEdit",
						type: "payEdit",
						width: 130,
					},
					{
						prop: "date",
						label: "日期",
						edit: "dataEdit",
						type: "dataEdit",
						width: 200,
					},
					{
						prop: "accountid",
						label: "结算账号",
						edit: "accountEdit",
						type: "accountEdit",
						width: 160,
					},
					{
						prop: "remark",
						label: "备注",
						edit: "remarkEdit",
						type: "remarkEdit",
						min_width: 200,
						align: "center",
					},
				],
				category: [],
				accountid: [],
				maxCount:1,
				formData: [{
					id: 0,
					type: '2',
					amount: '',
					date: '',
					account:'',
					accountid: '',
					category:'',
					categoryName:'',
					remark: '',
				}],
				selectAcc:"",
			}
		},
		mounted() {
			this.getCompanyAccounts()
			this.getCategory()
			this.formData[0].date = this.$common.format(new Date());
		},
		methods: {
			getCategory() {
				this.category = [];
				this.$api.getPaymentClassify({}).then(res => {
					let data = res.data.data;
					if(data.length>0){
						data.forEach(e=>{
							this.pushCate(e);
						})
					}
				}, () => {})
			},
			pushCate(e){
				this.category.push(e);
				if(e.children.length>0){
					e.children.forEach(s=>{
						this.pushCate(s);
					})
				}
			},
			getCompanyAccounts() {
				this.$api.companygetCompanyAccount({}).then(res => {
					if(res.data.code==1){
						let data = res.data.data;
						this.accountid = data;
						if(data.length>0){
							let index = 0;
							for(let i in data){
								if(data[i].isdefault==1){
									index = i;
									break;
								}
							}
							this.selectAcc = data[index].id;
							this.formData[index].accountid = this.selectAcc;
						}
					}
				}, () => {})
			},
			save() {
				for(let i in this.formData){
					let e = this.formData[i];
					if(e.type<1){
						this.$common.error("未选择类型");
						return;
					}
					if(e.amount<1){
						this.$common.error("金额未填写");
						return;
					}
					if(!e.date){
						this.$common.error("未选择时间");
						return;
					}
					if(e.accountid<1){
						this.$common.error("未选择结算账号");
						return;
					}
					for(let j in this.accountid){
						let acc = this.accountid[j];
						if(acc.id==e.accountid){
							e.account =  acc.name+'('+acc.account+')';
							break;
						}
					}
					if(e.category>0){
						for(let j in this.category){
							let cat = this.category[j];
							if(cat.id==e.category){
								e.categoryName = cat.label;
								break;
							}
						}
					}
				}
				let obj = {
					data:JSON.stringify(this.formData),
				}
				this.$api.batchAddPayment(obj).then(res => {
					if(res.data.code==1){
						if(this.$listeners['save']) {
							this.$emit("save", res);
						} else {
							this.$store.state.tagsView.visitedViews.splice(this.$store.state.tagsView.visitedViews.findIndex(item => item.path === this.$route.path), 1)
							this.$router.push("/finance/payment/list");
						}
						this.$notify({
							title: "新增收支",
							message: "添加收支成功",
							type: "success",
							duration: 1500,
						});
					}
				}, () => {})
			},
			cancel() {
				if(this.$listeners['cancel']) {
					// 如果提供执行
					this.$emit("cancel")
				} else {
					// 否侧执行其他
					this.$store.state.tagsView.visitedViews.splice(this.$store.state.tagsView.visitedViews.findIndex(item => item.path === this.$route.path), 1)
					this.$router.push(this.$store.state.tagsView.visitedViews[this.$store.state.tagsView.visitedViews.length - 1].path)
				}
			},
			addRow(row) {
				let index = this.getIndex(row);
				let obj = {
					id: this.maxCount,
					type: '2',
					amount: '',
					date: this.$common.format(new Date()),
					account:'',
					accountid: this.selectAcc,
					category:'',
					categoryName:'',
					remark: '',
				}
				if(index>=0){
					this.formData.splice(index+1, 0, obj);
				}else{
					this.formData.push(obj);
				}
				this.maxCount++;
			},
			removeRow(row){
				if(this.formData.length<=1){
					let obj = this.formData[0];
					if(obj!=null){
						obj.amount = "";
						obj.category = "";
						obj.categoryName = "";
						obj.remark = "";
					}
					return;
				}
				let index = this.getIndex(row);
				if(index>=0){
					this.formData.splice(index, 1);
				}
			},
			getIndex(row){
				let id = row.id;
				for(let i=0;i<this.formData.length;i++){
					if(this.formData[i].id==id){
						return i;
					}
				}
				return -1;
			}
		}
	}
</script>
